"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.hasRenderableContent = hasRenderableContent;
var _react = require("react");
/**
 * Determine whether a value that can be used as ReactNode has meaningful renderable content.
 * Returns false for:
 *  - null / undefined
 *  - boolean (React ignores booleans entirely)
 *  - empty string or string containing only whitespace
 *  - number that is NaN (would render as 'NaN')
 *  - an array where every entry itself is non‑renderable (recursively)
 *  - a valid React fragment with no children (or with children that are all non‑renderable)
 * Returns true for anything else (numbers, non-empty strings, elements, portals, etc.).
 */
function hasRenderableContent(node) {
  // null / undefined
  if (node == null) {
    return false;
  }

  // boolean nodes are ignored by React's renderer
  if (typeof node === 'boolean') {
    return false;
  }

  // numbers (filter out NaN)
  if (typeof node === 'number') {
    return !Number.isNaN(node);
  }

  // strings (must contain non-whitespace)
  if (typeof node === 'string') {
    return node.trim() !== '';
  }

  // arrays -> at least one child must be renderable
  if (Array.isArray(node)) {
    return node.some(child => hasRenderableContent(child));
  }

  // React elements
  if (/*#__PURE__*/(0, _react.isValidElement)(node)) {
    const element = node;
    // Fragments: must have at least one renderable child
    if (element.type === _react.Fragment) {
      const rawProps = element.props;
      let props = {};
      if (rawProps !== null && typeof rawProps === 'object' && !Array.isArray(rawProps) && Object.prototype.toString.call(rawProps) === '[object Object]') {
        props = rawProps;
      }
      return hasRenderableContent(props.children);
    }

    // All other elements are always renderable
    return true;
  }

  // Everything else (functions, symbols) is generally not provided directly; assume false for functions
  if (typeof node === 'function') {
    return false;
  }

  // Fallback: treat as truthy renderable (objects like ReactPortal, etc.)
  return true;
}
var _default = exports.default = hasRenderableContent;
